

const sevkBicimleriOptions = [
    {
        id: 1,
        name: "Forkliftle",
        status: false,
    },
    {
        id: 2,
        name: "Rampadan",
        status: false,
    },
    {
        id: 3,
        name: "Vinçle",
        status: false,
    },
    {
        id: 4,
        name: "Elle",
        status: false,
    },
    {
        id: 5,
        name: "Dökme",
        status: false,
    },
    {
        id: 6,
        name: "Yandan",
        status: false,
    },
    {
        id: 7,
        name: "Babalar Çıksın",
        status: false,
    }
]


export default sevkBicimleriOptions